
import {Device} from '../../base/Device';
/**
 * @author yeyuchao
 * @description bottom
 */
export default {
  props:{
    blackColor:Boolean,
  },
  data() {
    return {
      device:null,
      deviceMobile:false,
    };
  },
  mounted() {

  },
  created() {
    this.device = new Device();
    if(this.device.phone){
      this.deviceMobile = true;
    }
  },

  methods:{
    link(){
      window.open("https://beian.miit.gov.cn","_blank"); 
      // window.location.href = "https://beian.miit.gov.cn";
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/bottom/bottom.js